import _Object$create from "../../core-js/object/create";
export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = _Object$create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.9.2@@babel/runtime-corejs2/helpers/esm/inheritsLoose.js
// module id = 2453
// module chunks = 0